import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { IoAddSharp, IoCalendar, IoChevronDown } from 'react-icons/io5'
import { MdArrowForwardIos, MdArrowBackIosNew } from 'react-icons/md'
import clsx from 'clsx'
import { Menu, MenuItem, Typography } from '@mui/material'
import * as MeetingTypes from '../../Entities/MeetingTypes'
import dayjs from 'dayjs'
import { useMeetingStore } from './Store/MeetingStore'
import * as RoutePaths from '../../Entities/RoutePath'
import '../../Styles/ComplianceContainer.css'
import useCustomNavigate from '../../Common/ui/Navigate'
import CalendarRadio from './CalendarRadio'
import { BiTransferAlt } from 'react-icons/bi'
import { INITIATE } from 'src/Entities/CommonEntities'
import { formatDateParts } from 'src/lib/utils'

export default function CustomToolbar ({
    handleReassign,
    label,
    localizer: { messages },
    onNavigate,
    onView,
    view,
    views,
    date,
    hideCalendarActionContent,
    dateType,
    handleDateTypeChange,
    complianceCss,
    currentDate
}) {
    const customNavigate = useCustomNavigate()
    const [ anchorEl, setAnchorEl ] = useState(null)
    const [ anchorOption, setAnchorOption ] = useState(null)
    const { setDateFromMeetingSheduler } = useMeetingStore()
    const [ dateValue, setDateValue ] = useState('')

    useEffect(() => {
        setDateValue(date)
    }, [])

    useEffect(() => {
        if (view === MeetingTypes?.WEEK) {
            const start = dayjs(date).startOf(MeetingTypes?.WEEK).toDate()
            const end = dayjs(date).endOf(MeetingTypes?.WEEK).toDate()
            setDateFromMeetingSheduler({ from: start, to: end })
        }
    }, [dateValue])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (name) => {
        setAnchorEl(null)
        if (name === RoutePaths.RISK.NAME) {
            customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.RISK.URI + '/' + INITIATE, RoutePaths.RISK.NAME)
        }
    }

    const handleOpenOptionClick = (event) => {
        setAnchorOption(event.currentTarget)
    }

    const handleOptionClose = () => {
        setAnchorOption(null)
    }

    const handleNavigate = (action) => {
        onNavigate(action)
        setDateValue(date)
    }
    const isAdmin = JSON.parse(localStorage.getItem('isAdmin'))

    return (
        <div className={clsx('rbc-toolbar', { complianceCalendar: complianceCss })}>
            <span className={clsx('rbc-btn-group flex !justify-between !w-full !items-center', { complianceCalendar: complianceCss })}>
                <span className='flex items-center'>
                    <button
                        type="button"
                        onClick={() => handleNavigate(MeetingTypes.NAVIGATE.TODAY)}
                        aria-label={messages.today}
                    >
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <span style={{ padding: '0px 10px' }}>
                                <IoCalendar className='onboard-accordion-chevron' />
                            </span>
                            <span>
                                { new Date(date).getMonth() === new Date().getMonth() ? 'This Month' : 'Month' }
                            </span>
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={() => handleNavigate(MeetingTypes.NAVIGATE.PREVIOUS)}
                        aria-label={messages.previous}
                    >
                        <MdArrowBackIosNew className='onboard-accordion-chevron' />
                    </button>
                    <button
                        type="button"
                        onClick={() => handleNavigate(MeetingTypes.NAVIGATE.NEXT)}
                        aria-label={messages.next}
                    >
                        <MdArrowForwardIos className='onboard-accordion-chevron' />
                    </button>
                    <span className={clsx('rbc-btn-group', { complianceCalendar: complianceCss })} style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '8px' }}>
                        {/* {hideCalendarActionContent && (
                            <span style={{ fontWeight: '500', color: 'hsl(var(--primary))', fontSize: '12px' }}>Hard Target:</span>
                        )} */}
                        <span style={{ fontWeight: '500', color: 'hsl(var(--muted))' }}>{formatDateParts(currentDate)?.datePart}</span>
                    </span>
                </span>

                <span className='flex gap-4 items-center'>
                    {!isAdmin && <span className='flex cursor-pointer' onClick={() => handleReassign()}>  <BiTransferAlt size={20} style={{ marginRight: '8px', color: 'hsl(var(--primary))' }}/>
                        <span className='text-primary text-menu'>Reassign</span> </span>
                    }
                    <CalendarRadio handleDateTypeChange={handleDateTypeChange} dateType={dateType} />

                </span>
            </span>
            <span className={clsx('rbc-btn-group', { complianceCalendar: complianceCss })}>
                {!hideCalendarActionContent && <> <span className={clsx('rbc-btn-group', { complianceCalendar: complianceCss })}>
                    <span className="rbc-toolbar-label" onClick={handleClick} ><IoAddSharp style={{ border: '1px solid #007a78', color: '#007a78' }} /></span>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>Governance</MenuItem>
                        <MenuItem onClick={() => handleClose(RoutePaths.RISK.NAME)}>RisK</MenuItem>
                        <MenuItem onClick={handleClose}>Compliance</MenuItem>
                        <MenuItem onClick={handleClose}>Issue</MenuItem>
                        <MenuItem onClick={handleClose}>Board</MenuItem>
                        <MenuItem onClick={handleClose}>Annual General</MenuItem>
                        <MenuItem onClick={handleClose}>Other</MenuItem>
                    </Menu>
                </span>
                <span className={clsx('rbc-btn-group', { complianceCalendar: complianceCss })}>
                    <span className="rbc-toolbar-label flex flex-row justify-center items-center" onClick={handleOpenOptionClick}>
                        <Typography style={{ color: 'hsl(var(--primary))' }} >{view}</Typography><IoChevronDown style={{ color: 'hsl(var(--primary))' }} />
                    </span>
                    <Menu
                        anchorEl={anchorOption}
                        open={Boolean(anchorOption)}
                        onClose={handleOptionClose}
                    >
                        {views?.map((name) => (
                            name !== view && <MenuItem
                                key={name}
                                value={name}
                                className={clsx({ 'rbc-active': view === name })}
                                onClick={() => { onView(name); handleOptionClose() }}
                            >
                                {messages[name]}
                            </MenuItem>
                        ))}
                    </Menu>
                </span> </>}
            </span>
        </div>
    )
}

CustomToolbar.propTypes = {
    date: PropTypes.instanceOf(Date),
    label: PropTypes.string,
    localizer: PropTypes.object,
    messages: PropTypes.object,
    onNavigate: PropTypes.func,
    onView: PropTypes.func,
    view: PropTypes.string,
    views: PropTypes.array,
    hideCalendarActionContent: PropTypes.bool,
    complianceCss: PropTypes.bool
}
